import { usePusherCredentials } from '@/composables/credentials'
import Pusher from 'pusher-js'
import Echo from 'laravel-echo'

let echo = null

export const useEcho = () => {
  if (!echo) {
    echo = new Echo({
      Pusher,
      broadcaster: 'pusher',
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
      ...usePusherCredentials(),
    })
  }

  return echo
}
